import React from 'react';
import NodePersonalizado from './NodePersonalizado';

import "./style.scss"

export default function NodeVariavel({ data, id, type, ...rest }) {
    return <NodePersonalizado key={id} id={id} label={data.chave ? <span>{data?.chave}: {data?.valor || <i>NULL</i>}</span> : <span>{data?.etapa?.chave}: {data?.etapa?.valor || <i>NULL</i>}</span>} data={data} type={type} handles={1} {...rest} />
}